<template>
<div id="app" class="disclaimer-page page-template-default site container hfeed">
  <HeadNav selectedLanguage="en" page="disclaimer" :gotodownload="gotodownload" :apk="apk" />

  <div id="page" class="site-content">
    <main id="maincontent" class="site-main legal-wrap">
      <article class="inside-article section-content">
        <header class="entry-header">
          <h1 class="entry-title">
Disclaimer
</h1>
        </header>

        <div class="section-content">
          <p>
            The material on ogbwhats.com is general information. It may mention <strong>OG WhatsApp download</strong> steps, <strong>OG WhatsApp APK</strong> characteristics, or comparisons with other mods.
            Nothing here is legal advice, security auditing, or a promise that any unofficial build will stay online tomorrow.
          </p>

          <h2>Third-party software</h2>
          <p>
            WhatsApp is a trademark of its respective owner. We do not represent WhatsApp LLC or Meta. Modified clients are not official releases.
            When you sideload an APK, you choose to bypass the usual store pipeline—update checks, signing context, and policy enforcement work differently.
          </p>

          <h2>Risks you accept</h2>
          <p>
            Unofficial packages can include outdated libraries, aggressive permissions, or tampered binaries if someone intercepts the download path.
            Anti-virus warnings, account restrictions, or sudden crashes can happen even when a build labels itself “anti-ban.” No wording on this website overrides those realities.
          </p>

          <h2>Downloads</h2>
          <p>
            If our pages link out to files or mirrors, treat them like any other Internet binary: verify size, signature when provided, and pause when anything feels off.
            Back up chats before switching apps, and keep a recovery path if verification fails.
          </p>

          <p>
            Continued use of the site means you understand these limits. For data handling on ogbwhats.com itself, see the <router-link to="/privacy/">
Privacy Policy
</router-link>.
          </p>
        </div>
      </article>
    </main>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Disclaimer',
  components: { HeadNav },
  data() {
    return {
      apk: null,
      from: 'gb',
      filename: 'gb',
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          if (res.code == 200 && type == 1) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
  },
};
</script>

<style scoped>
.legal-wrap {
  max-width: 1120px;
  margin: 0 auto;
  padding: 24px 16px 48px;
}
h2 {
  margin-top: 1.5rem;
  color: #333333;
}
</style>
